import React, {useEffect, useId, useState} from 'react';
import * as Sentry from '@sentry/react';

let mermaidPromise = null;
const getMermaid = () => {
  if (!mermaidPromise) {
    mermaidPromise = import('mermaid').then(({default: mermaid}) => {
      mermaid.initialize({
        startOnLoad: false,
        securityLevel: 'strict',
        theme: 'neutral',
        fontFamily: 'inherit',
      });
      return mermaid;
    });
  }
  return mermaidPromise;
};

/**
 * Client-side Mermaid diagram renderer. The mermaid bundle is heavy, so it is
 * loaded lazily on first use. On a syntax/render error we fall back to showing
 * the raw diagram source and report to Sentry.
 */
const Mermaid = ({code}) => {
  const [svg, setSvg] = useState(null);
  const [failed, setFailed] = useState(false);
  const id = `mermaid-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;

  useEffect(() => {
    let cancelled = false;
    setFailed(false);
    getMermaid()
      .then((mermaid) => mermaid.render(id, code))
      .then(({svg: rendered}) => {
        if (!cancelled) setSvg(rendered);
      })
      .catch((e) => {
        if (cancelled) return;
        // eslint-disable-next-line no-console
        console.error('Mermaid diagram failed to render:', e);
        Sentry.captureException(e, {tags: {mdxComponent: 'Mermaid'}});
        setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (failed) {
    return (
      <pre className="text-sm whitespace-pre-wrap">{code}</pre>
    );
  }

  return (
    <div
      className="lesson-mermaid flex justify-center [&_svg]:max-w-full [&_svg]:h-auto"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={svg ? {__html: svg} : undefined}
    />
  );
};

export default Mermaid;
